import React from 'react'
import PropTypes from 'prop-types'
import UIOff from 'src/assets/img/house/nav_ui_off.png'
import UIOn from 'src/assets/img/house/nav_ui_on.png'

export const UIShowToggle = ({ onClick, isUIOn }) => {
  return (
    <button
      onClick={onClick}
      className="cursor-pointer hover:scale-105 transition-transform w-16 h-12"
    >
      {isUIOn ? (
        <img src={UIOn} alt="UI On" className="w-full h-full object-contain" />
      ) : (
        <img src={UIOff} alt="UI Off" className="w-full h-full object-contain" />
      )}
    </button>
  )
}

UIShowToggle.propTypes = {
  onClick: PropTypes.func,
  isUIOn: PropTypes.bool
}

UIShowToggle.defaultProps = {
  isUIOn: true
}
